<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Academic Files</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" md="8" lg="7">
                    <v-card flat class="pa-5">
                        <v-row justify="center">
                            <v-col cols="12" md="9">
                                <v-autocomplete dense outlined label="File Type" v-model="fileData.file_type_id"
                                    prepend-icon="mdi-file-document-outline" :items="fileTypeList" item-text="name"
                                    item-value="id" hide-details>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="9">
                                <v-radio-group row class="justify-center" v-model="fileData.upload_for"
                                    @change="onUploadTypeChange">

                                    <v-radio label="Division" value="division">
                                    </v-radio>

                                    <v-radio label="Course" value="course">
                                    </v-radio>

                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="fileData.upload_for == 'division'" justify="center">
                            <v-col cols="12" md="9">
                                <v-autocomplete dense outlined label="Division" v-model="fileData.division_id"
                                    prepend-icon="mdi-account-group" :items="divisionList" item-text="name"
                                    item-value="id">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="fileData.upload_for == 'course'" justify="center">
                            <v-col cols="12" md="9">
                                <v-autocomplete dense outlined label="Course" v-model="fileData.course_id"
                                    prepend-icon="mdi-book-open-page-variant" :items="courseList" item-text="name"
                                    item-value="id">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="9">
                                <v-file-input dense outlined show-size accept=".pdf,.doc,.docx,.xls,.xlsx"
                                    prepend-icon="mdi-paperclip" label="Select File" v-model="fileData.file">
                                </v-file-input>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="9" align="center">
                                <v-btn color="success" @click="uploadAcademicFile()" :loading="dialog_upload">
                                    <v-icon left>
                                        mdi-cloud-upload
                                    </v-icon>
                                    Upload
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-card class="mt-5">
            <v-card-title>
                Uploaded Files
            </v-card-title>
            <v-data-table dense :headers="headers" :items="uploadedFiles">

                <template v-slot:item.uploadFor="{ item }">
                    {{ item.division_name || item.course_name }}
                </template>

                <template v-slot:[`item.view_file`]="{ item }">
                    <span v-if="item.filepath">
                        <v-btn text color="primary" icon title="View File">
                            <a :href="awspath + item.filepath + item.filename" target="_blank"
                                style="text-decoration:none">
                                <v-icon>mdi-eye</v-icon>
                            </a>
                        </v-btn>
                    </span>

                    <span v-else>-</span>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>

            </v-data-table>

        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import moment from "moment";
export default {
    props: {
        instid: Number,
    },
    data() {
        return {
            org_id: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            fileData: {
                file_type_id: null,
                upload_for: 'division',
                division_id: null,
                course_id: null,
                file: null
            },
            fileTypeList: [],
            divisionList: [],
            courseList: [],
            headers: [
                {
                    text: 'File Type',
                    value: 'file_type'
                },
                {
                    text: 'Uploaded For',
                    value: 'upload_for'
                },
                {
                    text: 'View File',
                    value: 'view_file'
                },
                {
                    text: 'Uploaded By',
                    value: 'uploaded_by'
                },
                {
                    text: 'Upload Date',
                    value: 'upload_date'
                },
                {
                    text: 'Action',
                    value: 'action'
                }
            ],
            uploadedFiles: [],
            dialog_upload: false,
            awspath: null
        };
    },
    watch: {
        instid() {
            this.getAcademicFileData();
        },
    },
    mounted() {
        this.getAcademicFileData();
        this.org_id = localStorage.getItem("EPS-tenant");
        this.awspath = localStorage.getItem("awspath");
    },
    methods: {
        getAcademicFileData() {
            const formData = {
                instid: this.instid
            };

            axios
                .post("/EmployeeProfile/getAcademicFileData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.fileTypeList = res.data.file_type_list;
                        this.uploadedFiles = res.data.uploadedFiles;
                        this.divisionList = res.data.divisionList;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                });
        },
        getCourseListByInstructor() {
            const formData = {
                instid: this.instid
            };

            axios
                .post("/EmployeeProfile/getCourseListByInstructor", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.courseList = res.data.courseList;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onUploadTypeChange() {

            if (this.fileData.upload_for == "division") {

                this.fileData.course_id = null;

            } else {

                if (this.courseList.length == 0) {
                    this.getCourseListByInstructor();
                }

                this.fileData.division_id = null;
            }
        },
        uploadAcademicFile() {

            if (this.fileData.file_type_id == null || this.fileData.file_type_id == "") {
                this.showSnackbar("#b71c1c", "Please select File Type");
                return;
            }

            if (this.fileData.upload_for == "division" &&
                (this.fileData.division_id == null || this.fileData.division_id == "")) {

                this.showSnackbar("#b71c1c", "Please select Division");
                return;
            }

            if (this.fileData.upload_for == "course" &&
                (this.fileData.course_id == null || this.fileData.course_id == "")) {

                this.showSnackbar("#b71c1c", "Please select Course");
                return;
            }

            if (this.fileData.file == null) {
                this.showSnackbar("#b71c1c", "Please select file");
                return;
            }

            let formData = new FormData();

            formData.append("file", this.fileData.file);
            formData.append("instructor", this.instid);
            formData.append("file_type_id", this.fileData.file_type_id);
            formData.append("upload_for", this.fileData.upload_for);

            if (this.fileData.upload_for == "division") {
                formData.append("division_id", this.fileData.division_id);
            } else {
                formData.append("course_id", this.fileData.course_id);
            }

            this.dialog_upload = true;

            axios
                .post("/EmployeeProfile/saveAcademicFile", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {

                    if (res.data.status == "YES") {

                        this.showSnackbar(
                            "#4caf50",
                            "File uploaded successfully"
                        );

                        this.uploadedFiles = res.data.uploadedFiles;

                        this.fileData.file_type_id = null;
                        this.fileData.upload_for = "division";
                        this.fileData.division_id = null;
                        this.fileData.course_id = null;
                        this.fileData.file = null;

                    }
                    else if (res.data.status == "NOF") {

                        this.showSnackbar("#b71c1c", res.data.fmsg);

                    }
                    else {

                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }

                    this.dialog_upload = false;

                })
                .catch((error) => {

                    console.log(error);

                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong!"
                    );

                    this.dialog_upload = false;

                })
                .finally(() => {

                    this.dialog_upload = false;

                });
        },
        deleteItem(item) {
            if (confirm("Are you sure you want to delete this file?")) {
                const data = {
                    file_id: item.id,
                    instid: this.instid
                };
                axios
                    .post("/EmployeeProfile/deleteAcademicFile", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "File Deleted Successfully...");
                            this.uploadedFiles = res.data.academic_files_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
        }
    },
};
</script>
